import React from 'react'
import { Box, CircularProgress, CircularProgressProps, styled } from '@mui/material'
import { StyledComponent } from '@emotion/styled'
import { useIsMobile } from '@src/hooks'

export type LoadingProps = Omit<CircularProgressProps, 'size'> & {
  position?: 'fixed' | 'absolute' | 'static';
  backdrop?: 'black' | 'white' | 'none';
  size?: number;
}

const Loading: StyledComponent<LoadingProps> = styled(
  ({ className, color = 'secondary', size = 120, thickness = 1, ...props }: LoadingProps) => {
    const isMobile = useIsMobile()
    return (
      <Box className={className}>
        <CircularProgress
          {...props}
          color={color}
          size={isMobile ? Math.ceil(size / 1.5) : size}
          thickness={thickness}
          disableShrink
        />
      </Box>
    )
  }
)<LoadingProps>(
  ({ theme, position = 'absolute', backdrop = 'white' }) => {
    let background: string

    switch (backdrop) {
      case 'black':
        background = 'rgba(0, 0, 0, 0.35)'
        break
      case 'white':
        background = 'rgba(255, 255, 255, 0.35)'
        break
      default:
        background = 'none'
    }

    return {
      zIndex: theme.zIndex.modal + 1,
      justifyContent: 'center',
      alignItems: 'center',
      position: position,
      display: 'flex',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background,
    }
  }
)

export default Loading
